import { Form } from "antd";
import Select from "components/BaseWidgets/select";
import Input from "components/BaseWidgets/form/input";
import {
  useCourses,
  useIncomes,
  useProfession,
  useSelectOptions,
} from "hooks/api/useListing";
import { selectEmployment } from "../helper";
import { mapToSelectOptions } from "utils/formatHelper";

function CareerDetails({ form }) {
  // select apis
  const { jobSector, qualification } = useSelectOptions();
  const { data: courseData, isLoading: isCoursePending } = useCourses({
    search: "",
    parent_id: Form.useWatch("qualification", form),
  });
  const selectCourse = mapToSelectOptions(courseData);
  const { data: professionData, isLoading: isProfessionPending } =
    useProfession({
      search: "",
    });
  const selectProfession = mapToSelectOptions(professionData || []);
  const { data: incomeData, isLoading: isIncomePending } = useIncomes({
    search: "",
  });
  const selectAnnualIncome = mapToSelectOptions(incomeData);

  const othersProfession = selectProfession.find(
    (option) => option.label === "Other",
  );
  const selectedOccupation = Form.useWatch("occupation", form);
  const showSpecifyInput =
    selectedOccupation &&
    othersProfession &&
    selectedOccupation === othersProfession.value;

  return (
    <div className="about-bride-wrapper career-details-wrapper  flex flex-col items-center w-full">
      <div className="heading-wrapper w-full flex flex-col gap-2 mb-8">
        <p className="title font-title-xl">Career details</p>
        <p className="sub-text font-body-md2">
          Please enter the career and qualification details.
        </p>
      </div>
      <div className="basic-info-wrapper w-full mb-6">
        <div className="bride-form-container">
          <Form form={form} className="basic-form" layout="vertical">
            <Form.Item
              name="qualification"
              className="form-item m-0"
              rules={[
                {
                  required: true,
                  message: "Please select your qualification",
                },
              ]}
            >
              <Select
                widthVariant="wFull"
                placeholder="Select"
                labelClassName={`label`}
                inputClassName={`select-dropdown`}
                label="Qualification"
                options={qualification.options}
                isLoading={qualification.isLoading}
                onChange={(value) => {
                  form.setFieldsValue({
                    qualification: value,
                    course: null,
                  });
                }}
              />
            </Form.Item>

            <Form.Item
              name="course"
              className="form-item m-0"
              rules={[
                {
                  required: true,
                  message: "Please select your course",
                },
              ]}
            >
              <Select
                widthVariant="wFull"
                placeholder="Select"
                labelClassName={`label`}
                inputClassName={`select-dropdown`}
                label="Course"
                options={selectCourse}
                isLoading={isCoursePending}
              />
            </Form.Item>

            <Form.Item
              name="occupation"
              className="form-item m-0"
              rules={[
                {
                  required: true,
                  message: "Please select your profession",
                },
              ]}
            >
              <Select
                widthVariant="wFull"
                placeholder="Select"
                labelClassName={`label`}
                inputClassName={`select-dropdown`}
                label="Profession"
                options={selectProfession}
                isLoading={isProfessionPending}
                onChange={(value) => {
                  form.setFieldsValue({
                    occupation: value,
                    specify_occupation: null,
                  });
                }}
              />
            </Form.Item>

            {showSpecifyInput && (
              <Form.Item
                name="specify_occupation"
                className="form-item m-0"
                rules={[
                  {
                    required: true,
                    message: "Please specify your profession",
                  },
                ]}
              >
                <Input
                  id="specify-profession"
                  labelClass={`label`}
                  label="Specify profession"
                  placeholder="Enter your profession"
                />
              </Form.Item>
            )}

            <Form.Item
              name="employment_type"
              className="form-item m-0"
              rules={[
                {
                  required: true,
                  message: "Please select your Employment",
                },
              ]}
            >
              <Select
                widthVariant="wFull"
                placeholder="Select"
                labelClassName={`label`}
                inputClassName={`select-dropdown`}
                label="Employment"
                options={selectEmployment}
              />
            </Form.Item>

            <Form.Item
              name="annual_income"
              className="form-item m-0"
              rules={[
                {
                  required: true,
                  message: "Please select your annual income",
                },
              ]}
            >
              <Select
                widthVariant="wFull"
                placeholder="Select"
                labelClassName={`label`}
                inputClassName={`select-dropdown`}
                label="Annual Income"
                options={selectAnnualIncome}
                isLoading={isIncomePending}
              />
            </Form.Item>

            <Form.Item
              name="sector"
              className="form-item m-0"
              rules={[
                {
                  required: true,
                  message: "Please select your Sector",
                },
              ]}
            >
              <Select
                widthVariant="wFull"
                placeholder="Select"
                labelClassName={`label`}
                inputClassName={`select-dropdown`}
                label="Sector"
                options={jobSector.options}
                isLoading={jobSector.isLoadin}
              />
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default CareerDetails;
